import "./home.css";
const Fotter = () => {
  return (
    <>
      <div style={{ background: "black" }}>
        <footer className="m-footer">
          <div className="container">
            <div className="m-footer__top">
              <div className="m-footer__top__left">
                <div className="m-footer__top__left__newsletter">
                  <div className="newsletter-block">
                    <span>
                      Sign up for our newsletter and we’ll keep you up-to-date
                      with all OTT and IPTV news
                    </span>

                    <div
                      role="form"
                      className="wpcf7"
                      id="wpcf7-f545-o1"
                      lang="en-US"
                      dir="ltr"
                    >
                      <form
                        action="/?gclid=Cj0KCQjwt_qgBhDFARIsABcDjOfNwhQG4oskEPKWiL8v2OjOmiOh-UBkjbgCCxdf0TEGWYKRDIoBbXwaAnpdEALw_wcB#wpcf7-f545-o1"
                        method="post"
                        className="wpcf7-form init mailchimp-ext-0.5.64"
                        novalidate="novalidate"
                        data-status="init"
                      >
                        <div className="form-group">
                          <div className="namefield">
                            <span className="wpcf7-form-control-wrap your-name">
                              <input
                                type="text"
                                name="your-name"
                                value=""
                                size="40"
                                className="wpcf7-form-control wpcf7-text"
                                aria-invalid="false"
                              />
                            </span>
                          </div>
                          <div className="emailfield">
                            <label>
                              <br />
                              <span className="wpcf7-form-control-wrap your-email">
                                <input
                                  type="email"
                                  name="your-email"
                                  value=""
                                  size="40"
                                  className="wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email"
                                  aria-required="true"
                                  aria-invalid="false"
                                  placeholder="Your email address"
                                />
                              </span>
                            </label>
                          </div>
                          <p>
                            <label className="submit btn-blue">
                              <input
                                type="submit"
                                value="submit"
                                className="wpcf7-form-control wpcf7-submit"
                              />
                              <br />
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                              >
                                <rect width="16" height="16" fill="none"></rect>
                                <path
                                  d="M.745.419A.5.5,0,0,0,0,.855v6.29a.5.5,0,0,0,.745.436L6.336,4.436a.5.5,0,0,0,0-.872Z"
                                  transform="translate(9 4)"
                                  fill="#fff"
                                ></path>
                                <rect
                                  width="10"
                                  height="2"
                                  rx="0.5"
                                  transform="translate(0 7)"
                                  fill="currentColor"
                                ></rect>
                              </svg>
                            </label>
                          </p>
                        </div>

                        <div
                          className="wpcf7-response-output"
                          aria-hidden="true"
                        ></div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div className="m-footer__top__right">
                <ul id="footer-menu" className="menu">
                  <li
                    id="menu-item-68"
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-68"
                  >
                    <a>Markets</a>
                    <ul className="sub-menu">
                      <li
                        id="menu-item-803"
                        className="menu-item menu-item-type-custom menu-item-object-custom menu-item-803"
                      >
                        <a>Mobile Operators</a>
                      </li>
                      <li
                        id="menu-item-804"
                        className="menu-item menu-item-type-custom menu-item-object-custom menu-item-804"
                      >
                        <a>System integrators</a>
                      </li>

                      <li
                        id="menu-item-807"
                        className="menu-item menu-item-type-custom menu-item-object-custom menu-item-807"
                      >
                        <a>Content owners</a>
                      </li>

                      <li
                        id="menu-item-809"
                        className="menu-item menu-item-type-custom menu-item-object-custom menu-item-809"
                      >
                        <a>TV as a Service Providers</a>
                      </li>
                      <li
                        id="menu-item-810"
                        className="menu-item menu-item-type-custom menu-item-object-custom menu-item-810"
                      >
                        <a>Cable Companies</a>
                      </li>
                      <li
                        id="menu-item-811"
                        className="menu-item menu-item-type-custom menu-item-object-custom menu-item-811"
                      >
                        <a>Cooperatives</a>
                      </li>
                    </ul>
                  </li>
                  <li
                    id="menu-item-69"
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-69"
                  >
                    <a>Company</a>
                    <ul className="sub-menu">
                      <li
                        id="menu-item-746"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-746"
                      >
                        <a>About us</a>
                      </li>
                      <li
                        id="menu-item-143"
                        className="menu-item menu-item-type-custom menu-item-object-custom menu-item-143"
                      >
                        <a>Newsroom</a>
                      </li>
                      <li
                        id="menu-item-144"
                        className="menu-item menu-item-type-custom menu-item-object-custom menu-item-144"
                      >
                        <a>Events</a>
                      </li>
                      <li
                        id="menu-item-216"
                        className="menu-item menu-item-type-custom menu-item-object-custom menu-item-216"
                      >
                        <a>Partners</a>
                      </li>
                      <li
                        id="menu-item-750"
                        className="menu-item menu-item-type-custom menu-item-object-custom menu-item-750"
                      >
                        <a>Cases</a>
                      </li>
                      <li
                        id="menu-item-85"
                        className="menu-item menu-item-type-custom menu-item-object-custom menu-item-85"
                      >
                        <a> </a>
                      </li>
                      <li
                        id="menu-item-744"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-744"
                      >
                        <a>Services</a>
                      </li>
                      <li
                        id="menu-item-745"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-745"
                      >
                        <a>Support</a>
                      </li>
                      <li
                        id="menu-item-88"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-88"
                      >
                        <a>Contact</a>
                      </li>
                      <li
                        id="menu-item-3527"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-3527"
                      >
                        <a>DMCA</a>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <a>Contact us</a>
                    <ul className="sub-menu">
                      <li>
                        <a href="#">iptv-store</a>
                      </li>
                      <li>
                        <a href="tel:+31 87 170 4879">
                          +31 85 130 3803 (Worldwide)
                        </a>
                      </li>
                      <li>
                        <a href="tel:+1 813 958 4026">+1 813 536 4096 (USA)</a>
                      </li>
                      <li>
                        <a href="mailto:sales@iptv-store.com">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                          >
                            <rect width="16" height="16" fill="none" />
                            <path
                              d="M2.362,11.787A2.362,2.362,0,0,1,0,9.427v-6.1l7.519,4.59a.908.908,0,0,0,.944,0L16,3.325v6.1a2.362,2.362,0,0,1-2.362,2.361ZM.076,1.851A2.348,2.348,0,0,1,2.362,0H13.639a2.348,2.348,0,0,1,2.286,1.851L8.009,6.687Z"
                              transform="translate(0 2)"
                              fill="currentColor"
                            />
                          </svg>
                          sales@iptv-store.com
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>

            <div className="m-footer__bottom">
              <div className="m-footer__bottom__text">
                <span>
                  Screenshots are for illustrative purposes only. Operators must
                  obtain content rights from respective content owners |
                  iptv-store All Rights Reserved. 2023.
                </span>{" "}
              </div>
              <div className="m-footer__bottom__flex">
                <div className="m-footer__bottom__flex__menu">
                  <div className="menu-footer-bottom-menu-container"></div>
                </div>
                <div className="m-footer__bottom__flex__socials">
                  <a href="https://twitter.com/">
                    <i class="fa-brands fa-cc-visa"></i>
                  </a>
                  <a href="https://twitter.com/">
                    <i class="fa-brands fa-cc-mastercard"></i>
                  </a>
                  <a href="https://twitter.com/">
                    <i class="fa-brands fa-cc-paypal"></i>
                  </a>
                  <a href="https://twitter.com/">
                    <i class="fa-brands fa-cc-stripe"></i>
                  </a>
                  <a href="https://twitter.com/">
                    <i class="fa-brands fa-cc-discover"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Fotter;
